import * as React from "react";
import { Segment, Header, Icon, Button } from "semantic-ui-react";

interface Props {
    children: React.ReactNode;
}

interface State {
    hasError: boolean;
}

class SectionErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(_: Error): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error("Section Error:", error, errorInfo);
    }

    handleRetry = () => {
        this.setState({ hasError: false });
    }

    render() {
        if (this.state.hasError) {
            return (
                <Segment placeholder={true} textAlign="center" style={{ borderRadius: '2px', border: '1px solid rgba(255, 0, 0, 0.2)' }}>
                    <Header icon={true}>
                        <Icon name="warning sign" color="red" />
                        Something went wrong in this section.
                    </Header>
                    <Button primary={true} onClick={this.handleRetry}>Try Again</Button>
                </Segment>
            );
        }

        return this.props.children;
    }
}

export default SectionErrorBoundary;
